import { useState } from 'react'

const useInput = (initialValue, callBack) => {
  const [value, setValue] = useState(initialValue)

  return {
    value,
    setValue,
    reset: () => setValue(''),
    bind: {
      value,
      onChange: (event) => {
        setValue(event.target.value)
        if (callBack) callBack(event.target.value)
      }
    }
  }
}

export default useInput
